import React, {FC} from 'react';
import { style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';
import { ActionButton } from '@src/components/ActionButton';
import { LocalizedStrings } from '@src/utils/localizedStrings';

interface FineTunedOverlayProps {
  message?: string;
  onReset: () => void;
  onAdvancedSettings: () => void;
  resetButtonText?: string;
  advancedButtonText?: string;
}

/**
 * Reusable overlay component that shows a "fine-tuned" message with 
 * reset and advanced settings buttons
 */
export const FineTunedOverlay: FC<FineTunedOverlayProps> = ({
  message = lang.fineTuned,
  onReset,
  onAdvancedSettings,
  resetButtonText = lang.resetButton,
  advancedButtonText = lang.advancedButton
}) => {
  return (
    <div className={overlayStyle}>
      <p>{message}</p>
      <div className={buttonsContainerStyle}>
        <ActionButton 
          onClick={onReset} 
          variant="transparent"
          size='small'
        >
          {resetButtonText}
        </ActionButton>
        <ActionButton 
          onClick={onAdvancedSettings} 
          variant="blue"
          size='small'
        >
          {advancedButtonText}
        </ActionButton>
      </div>
    </div>
  );
};

const overlayStyle = style({
  backgroundColor: 'transparent',
  border: `1px solid ${ADALONG_COLORS.LIGHT_GRAY}`,
  padding: '5px 0 15px',
  borderRadius: '10px',
  textAlign: 'center',
  maxWidth: '100%',
  fontSize: '12px',
});

const buttonsContainerStyle = style({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '15px',
  gap: '10px'
});

const lang = LocalizedStrings({
  en: {
    fineTuned: 'This setting has been fine-tuned',
    resetButton: 'Reset',
    advancedButton: 'Advanced Settings'
  },
});
